// use-user-status.ts
'use strict';
import { Auth, Hub } from 'aws-amplify';
import { useEffect, useState } from 'react';

/**
 * userUserStatus is a react hook that tracks the user's login status and provides a "isLoggedIn" flag that can be checked in code.
 */

const useUserStatus = () => {
  let [user, setUser] = useState(null);

  useEffect(() => {
    let updateUser = async () => {
      try {
        let currentUser = await Auth.currentAuthenticatedUser();
        setUser(currentUser);
      } catch {
        if (setUser) {
          setUser(null);
        }
      }
    };
    Hub.listen('auth', updateUser); // listen for login/signup events

    // we are not using async to wait for updateUser, so there will be a flash of page where the user is assumed not to be logged in. If we use a flag
    updateUser()
      .then()
      .catch((e) => {
        console.log('Error attempting to Update User');
        console.error(e);
      }); // check manually the first time because we won't get a Hub event

    return () => {
      console.log('Cleaning up with hub.remove');
      Hub.remove('auth', updateUser);
    }; // cleanup
  }, []);

  return user;
};

export default useUserStatus;
